/**
 * @file:
 * @author: chenyingliao <chenyingliao@baidu.com>
 * @Date: 2023-10-19 16:54:16
 * @LastEditors: chenyingliao <chenyingliao@baidu.com>
 * @LastEditTime: 2023-10-19 17:17:48
 * @FilePath: /console-znzs/new_src/components/SvgIcon/index.js
 */
import SVGIcon from './SVGIcon';

SVGIcon.install = Vue => {
    Vue.component('z-svg-icon', SVGIcon);
};

export default SVGIcon;